export default __webpack_public_path__ + "static/media/victoria-commercial-bank-logo.472de3b1.png";